import React from 'react';
// import ReactDOM from 'react-dom';
import App from './App';
import 'mapbox-gl/dist/mapbox-gl.css';
import { Auth0Provider } from "@auth0/auth0-react";
import { createRoot } from 'react-dom/client';

const urlParams = new URLSearchParams(window.location.search);
const organization = urlParams.get("organization");
const invitation = urlParams.get("invitation");

let container = organization && invitation ?
    <Auth0Provider
        domain="auth.fastmap.ai"
        clientId="05gpcoHjKgVEWpMdwKOxXxHal1nigu4W"
        redirectUri={window.location.origin}
        audience="https://fastmap.us.auth0.com/api/v2/"

        organization={urlParams.get("organization")}
        invitation={urlParams.get("invitation")}
    >
        <App />
    </Auth0Provider>
    :
    window.location.pathname.split('/')[1] == "signup" ?
        <Auth0Provider
            domain="auth.fastmap.ai"
            clientId="05gpcoHjKgVEWpMdwKOxXxHal1nigu4W"
            redirectUri={window.location.origin}
            audience="https://fastmap.us.auth0.com/api/v2/"
            screen_hint="signup"
        >
            <App />
        </Auth0Provider> :
        <Auth0Provider
            domain="auth.fastmap.ai"
            clientId="05gpcoHjKgVEWpMdwKOxXxHal1nigu4W"
            redirectUri={window.location.origin}
            audience="https://fastmap.us.auth0.com/api/v2/"
        >
            <App />
        </Auth0Provider>

const root = createRoot(document.getElementById('root'));
root.render(container);

// ReactDOM.render(container, document.getElementById('root'));
